<template>
     <div class="backTop">
          <van-icon name="arrow-up" />
        </div>
</template>
<script>
import $ from "jquery";
export default {
  name: "BackTop",
  methods: {
    bingScrollTop() {
      $(window).scroll(function() {
        if ($(document).scrollTop() > 400) {
          $(".backTop").show();
        } else {
          $(".backTop").hide();
        }
      });
      $(".backTop").click(function() {
        $(document).scrollTop(0);
      });
    }
  },
  mounted() {
    this.bingScrollTop();
  }
};
</script>
<style lang="less" scoped>
.backTop {
  position: fixed;
  bottom: 80px;
  right: 20px;
  display: none;
  i {
    padding: 10px;
    font-size: 18px;
    border-radius: 100%;
    border: 1px solid #ddd;
    background-color: #f7f7ff;
  }
}
</style>


